import { Box, Section, Stack } from "@vinomofo/components";

import { CartDropdown } from "../cart-dropdown";
import { HeaderAuth } from "./HeaderAuth";
import { HeaderCategoryNav } from "./HeaderCategoryNav";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderSearch } from "./HeaderSearch";
import { storefrontNavigationItemProps } from "../../types/vino-data-types";

export const HeaderWide = ({
  menuItems,
  isWhiskymofoEnabled,
}: {
  menuItems: storefrontNavigationItemProps[];
  isWhiskymofoEnabled: boolean;
}): JSX.Element => {
  return (
    <Section py={["15px", "20px", "20px"]} backgroundColor="secondary">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box flexGrow={3} flexShrink={1} flexBasis={0}></Box>
        <Box
          flexGrow={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <HeaderLogo
            height={["24px", "32px", "38px"]}
            isWhiskymofoEnabled={isWhiskymofoEnabled}
          />
        </Box>
        <Box
          as="nav"
          display="flex"
          flexGrow={3}
          flexShrink={1}
          flexBasis={0}
          justifyContent="flex-end"
          alignItems="center"
          gridGap={[3, 3, 4]}
        >
          <HeaderAuth isLarge />
          <HeaderSearch />
          <CartDropdown isLarge />
        </Box>
      </Box>
      {/* {withCategoryNavigation ? ( */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexBasis="100%"
        paddingTop="15px"
        position="relative"
      >
        <HeaderCategoryNav menuItems={menuItems} fontSize={[0, 1]} />
      </Box>
      {/* ) : null} */}
    </Section>
  );
};
